import { useState, useEffect, useRef } from 'react';
import { useAppSelector } from '../store';
import { getAllEmployees } from '../services/employeeDB';
import type { EmployeeRecord } from '../types/employees';

export function useEmployeeRecords(dbKey: string): EmployeeRecord[] {
  const [records, setRecords] = useState<EmployeeRecord[]>([]);
  const isLoading = useAppSelector((s) => s.employees.isLoading);
  const prevLoadingRef = useRef<boolean | null>(null);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = isLoading;

    // Load on mount (wasLoading === null) or when sync finishes (true → false)
    const shouldLoad = wasLoading === null || (wasLoading === true && !isLoading);
    if (!shouldLoad) return;

    getAllEmployees(dbKey)
      .then((data) => { if (data.length > 0) setRecords(data); })
      .catch(() => {});
  }, [dbKey, isLoading]);

  return records;
}
